import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import theme from 'theme'

const NavIcon = forwardRef(({ open, ...rest }, ref) => (
  <div
    ref={ref}
    css={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: theme.space[2],
      width: theme.space[6],
      height: theme.space[6],
      backgroundColor: open ? theme.colors.white[0] : theme.colors.steel[2],
      border: theme.border.base,
      borderRadius: '100%',
      color: open ? theme.colors.blue[0] : theme.colors.gray[1],
      borderColor: open ? theme.colors.border[0] : theme.colors.steel[2],
      marginLeft: theme.space[3],
      transition:
        'background-color 100ms ease-in-out, color 100ms ease-in-out, border-color 100ms ease-in-out',

      '&:hover, &:focus': {
        backgroundColor: theme.colors.white[0],
        borderColor: theme.colors.border[0],
        color: theme.colors.blue[0]
      }
    }}
    {...rest}
  />
))

NavIcon.propTypes = {
  open: PropTypes.bool
}

NavIcon.displayName = 'NavIcon'

export default NavIcon
